import React from 'react'

import { BenefitSection } from '@components/sections/technologies/devops/devopsAndCloud/BenefitSection'
import { DevOpsExperienceSection } from '@components/sections/technologies/devops/devopsAndCloud/DevOpsExperienceSection'
import { DevOpsExpertiseSection } from '@components/sections/technologies/devops/devopsAndCloud/DevOpsExpertiseSection'
import { DevOpsHeaderSection } from '@components/sections/technologies/devops/devopsAndCloud/DevOpsHeaderSection'
import { DevOpsQuickFacts } from '@components/sections/technologies/devops/devopsAndCloud/DevOpsQuickFacts'
import { DevOpsSolutions } from '@components/sections/technologies/devops/devopsAndCloud/DevOpsSolutions'
import { DevOpsSuccessSection } from '@components/sections/technologies/devops/devopsAndCloud/DevOpsSuccessSection'
import { GetFreeSection } from '@components/sections/technologies/devops/devopsAndCloud/GetFreeSection'
import { TakeYourBusinessSection } from '@components/sections/technologies/devops/devopsAndCloud/TakeYourBusinessSection'
import { PageContent } from '@theme'
import { CustomHead } from '@ui/sections/CustomHead'

export default function DevOpsAndCloud() {
  return (
    <>
      <CustomHead
        title="Cloud Integration Services | Dedicated Cloud Experts"
        description="Uncover the benefits of agile Cloud development for your business growth. Go for experienced Cloud and DevOps Modsen engineers."
        imagePath="/images/custom-head/custom-head-devops-and-cloud.webp"
      />
      <PageContent>
        <DevOpsHeaderSection />
        <DevOpsExperienceSection />
        <DevOpsQuickFacts />
        <DevOpsSolutions />
        <GetFreeSection />
        <BenefitSection />
        <DevOpsExpertiseSection />
        <DevOpsSuccessSection />
      </PageContent>
      <TakeYourBusinessSection />
    </>
  )
}
